import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, MenuController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DashMedanPage } from '../dash-medan/dash-medan';

declare var google;

@IonicPage({
  name: 'monitoring-page',
  segment: 'monitoring',
})
@Component({
  selector: 'page-monitoring',
  templateUrl: 'monitoring.html',
})
export class MonitoringPage {
  @ViewChild('lineCanvas') lineCanvas: ElementRef;

  @ViewChild('map')
  mapElement: ElementRef;

  map: any;
  markerMPP = {};
  infoWindowMPP = {};
  infoboxMPP = {};
  bounds: any;

  ENGINE: any = ['MDNTM01', 'MDNTM02', 'MDNTM03'];
  TAGS: any = ['U1_AQ7651', 'U1_AQ7653'];

  loadData = {};
  registerSocketData = {};
  data = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private menuCtrl: MenuController,
    private socket: Socket,
    private toastCtrl: ToastController
  ) {}

  structuringData() {
    this.ENGINE.forEach((engine) => {
      this.data[engine] = {};
      this.TAGS.forEach((tags) => {
        this.data[engine][tags] = 0;
      });
    });
  }

  registerSocket() {
    this.ENGINE.forEach((engine) => {
      this.registerSocketData[engine] = {};
      this.TAGS.forEach((tags) => {
        this.registerSocketData[engine][tags] = this.getSocketData(engine, tags).subscribe((data: any) => {
          var x_tags = data.NAME.substring(data.NAME.length, 14);

          if (
            x_tags === 'U1_AI0011' ||
            x_tags === 'U1_AI0389' ||
            x_tags === 'U1_AI0085' ||
            x_tags === 'U1_AI0087' ||
            x_tags === 'U1_AI0089' ||
            x_tags === 'U1_AI0091' ||
            x_tags === 'U1_AI0093' ||
            x_tags === 'U1_AI0095' ||
            x_tags === 'U1_AI0097' ||
            x_tags === 'U1_AI0099' ||
            x_tags === 'U1_AI0101' ||
            x_tags === 'U1_AI0103' ||
            x_tags === 'U1_AI0105' ||
            x_tags === 'U1_AI0107' ||
            x_tags === 'U1_AI0401' ||
            x_tags === 'U1_AI0402' ||
            x_tags === 'U1_AI0403' ||
            x_tags === 'U1_AI0404'
          ) {
            // DIV 10
            if (data.NILAI === 0 || data.NILAI < 0) {
              this.data[engine][x_tags] = data.NILAI.toFixed(2);
            } else {
              this.data[engine][x_tags] = (data.NILAI / 10).toFixed(2);
            }
          } else if (x_tags === 'U1_AQ7651' || x_tags === 'U1_AQ7653' || x_tags === 'U1_AQ7657') {
            // DIV 1000
            if (data.NILAI === 0 || data.NILAI < 0) {
              this.data[engine][x_tags] = data.NILAI.toFixed(2);
            } else {
              this.data[engine][x_tags] = (data.NILAI / 1000).toFixed(2);
            }
            this.data[engine].last = data.TIMESTAMP;
          } else {
            if (data.NILAI === 0 || data.NILAI < 0) {
              this.data[engine][x_tags] = data.NILAI.toFixed(2);
            } else {
              this.data[engine][x_tags] = parseFloat(data.NILAI).toFixed(2);
            }
          }
        });
      });
    });
  }

  getSocketData(engine, tags) {
    let observable = new Observable((observer) => {
      this.socket.on(`stream-V_${engine}_${tags}`, (data) => {
        observer.next(data);
      });
    });
    return observable;
  }

  ionViewDidEnter() {
    if (!google) {
      this.showToast('ERROR: Failed to load maps. Please check your internet connection.');
    } else {
      // -5.5184537,105.346001 MPP Tarahan 4x25 MW
      // 1.2100701,97.6760703 MPP Gunung Sitoli 1x25 MW
      // 1.0719337,101.2798429 MPP Balai Pungut 3x25 MW
      // -2.0770623,106.1468956 MPP Air Anyir 2x25 MW
      // -2.8915749,107.5638194 MPP Suge 1x25 MW
      // 0.0590372,109.2016659 MPP Parit Baru 4x25 MW
      // -8.6598072,116.0720074 MPP Jeranjang 2x25 MW
      // 3.7132315,98.6622996 MPP Paya Pasir 3x25 MW
      //id, name, lat, lng, priority
      var MPP = [
        {
          id: 'MDN',
          name: 'MPP Paya Pasir',
          lat: 3.7132315,
          lon: 98.6622996,
        },
        {
          id: 'NIA',
          name: 'MPP Gunung Sitoli',
          lat: 1.2100701,
          lon: 97.6760703,
        },
        {
          id: 'DUR',
          name: 'MPP Balai Pungut',
          lat: 1.0719337,
          lon: 101.2798429,
        },
        {
          id: 'BGK',
          name: 'MPP Air Anyir',
          lat: -2.0770623,
          lon: 106.1468956,
        },
        {
          id: 'BLT',
          name: 'MPP Suge',
          lat: -2.8915749,
          lon: 107.5638194,
        },
        {
          id: 'LPG',
          name: 'MPP Tarahan',
          lat: -5.5184537,
          lon: 105.346001,
        },
        {
          id: 'PON',
          name: 'MPP Parit Baru',
          lat: 0.0590372,
          lon: 109.2016659,
        },
        {
          id: 'LOM',
          name: 'MPP Jeranjang',
          lat: -8.6598072,
          lon: 116.0720074,
        },
      ];

      this.bounds = new google.maps.LatLngBounds();

      MPP.forEach((element) => {
        this.addMPPMarker(element.id, element.name, element.lat, element.lon);
        this.bounds.extend(new google.maps.LatLng(element.lat, element.lon));
      });
    }

    this.structuringData();
    this.registerSocket();
  }

  ionViewDidLoad() {
    this.menuCtrl.enable(true);
    if (!google) {
      this.showToast('ERROR: Failed to load maps. Please check your internet connection.');
    } else {
      this.loadMap();
    }
  }

  loadMap(): void {
    let mapStyles = [
      {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [
          {
            lightness: 33,
          },
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative.country',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            color: '#fc9106',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [
          {
            lightness: 20,
          },
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#f1f2f3',
          },
        ],
      },
    ];

    let latLng = new google.maps.LatLng(-0.4739546, 107.6425363);

    let mapOptions = {
      center: latLng,
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      styles: mapStyles,
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);

    google.maps.event.addListenerOnce(map, 'idle', function () {
      this.map.fitBounds(this.bounds);
      this.map.panToBounds(this.bounds);
    });
  }

  addMPPMarker(id, name, lat, lng) {
    let markerIcon;
    markerIcon = {
      url: 'assets/icon/marker/MPP.png',
      scaledSize: new google.maps.Size(128, 32),
      anchor: new google.maps.Point(64, 32), // lets offset the marker image
      labelOrigin: { x: 64, y: 38 },
    };

    this.markerMPP[id] = new google.maps.Marker({
      icon: markerIcon,
      opacity: 0.8,
      map: this.map,
      position: { lat: parseFloat(lat), lng: parseFloat(lng) },
      label: {
        text: name,
        fontSize: '12px',
        fontFamily: 'PT Sans Narrow',
        fontWeight: 'bold',
      },
    });
  }

  openPageMedan(): void {
    this.navCtrl.setRoot(DashMedanPage);
  }

  ionViewWillLeave() {
    this.ENGINE.forEach((engine) => {
      this.TAGS.forEach((tags) => {
        this.socket.removeListener(`stream-V_${engine}_${tags}`);
      });
    });
  }

  ionViewDidLeave() {
    // Unload registerSocketData subscirber (if any)
    Object.keys(this.registerSocketData).forEach((key) => {
      // console.log('Socket data this.registerSocketData', key);
      Object.keys(this.registerSocketData[key]).forEach((subkey) => {
        // console.log('Socket data this.registerSocketData', key, subkey);
        this.registerSocketData[key][subkey].unsubscribe();
      });
    });
  }

  private showToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/monitoring/monitoring.ts